import { Controller } from "stimulus";
import { Modal } from "bootstrap"

// 携帯電話番号の入力モーダル画面のコントローラ
export default class extends Controller {
  static targets = ["smsPhoneFiledNew", "smsPhoneFiledCheck", "smsVerificationsNew", "smsVerificationsCheck",
                    "errorExplanationNew", "errorExplanationCheck", "closeButton"];

  connect() {
    const submitButton = document.querySelector('button[name="new_order"]');
    this.modal = new Modal(this.element)

    // Ajaxエラー時
    this.element.addEventListener("ajax:error", (event) => {
      // エラーメッセージHTMLの生成
      const messages = event.detail[0].map(message => {
        return `<li>${message}</li>`
      }).join("");

      // 入力項目表示状態に従い、エラーメッセージの表示対象を決定し、メッセージ表示する
      const error_ExplanationTarget = this.isNewModal() ? this.errorExplanationNewTarget : this.errorExplanationCheckTarget;
      error_ExplanationTarget.innerHTML = `
      <div class="alert alert-danger" id="error_explanation" role="alert">
        <ul data-sms-verifications-target="error_explanation">
          ${messages}
        </ul>
      </div>
      `;
    })

    // Ajax成功時
    this.element.addEventListener("ajax:success", (event) => {
      // 携帯番号の入力時は、認証コードの入力に切り替える
      if (this.isNewModal()) {
        this.changeModal();
      } else {
        // 認証コードの入力時は、モーダルを閉じる
        submitButton.dataset.submitFlag = "true";
        this.onEnd();
      }
    });
  }

  newSubmit() {
    this.smsPhoneFiledCheckTarget.value = this.smsPhoneFiledNewTarget.value
  }

  /**
   * 携帯番号の入力をリセットし、入力項目を表示する
   */
  resend() {
    this.smsPhoneFiledNewTarget.value = "";
    this.smsPhoneFiledCheckTarget.value = "";

    // モーダル内の入力項目（電話番号／認証コード）の表示を切り替える
    this.changeModal();
  }

  /**
   * SMS認証コードの入力項目が表示されているか判定する
   */
  isNewModal() {
    return this.smsVerificationsNewTarget.classList.contains("d-display");
  }

  /**
   * モーダル内の入力項目（電話番号／認証コード）の表示を切り替える
   */
  changeModal() {
    this.smsVerificationsNewTarget.classList.toggle('d-none');
    this.smsVerificationsNewTarget.classList.toggle('d-display');

    this.smsVerificationsCheckTarget.classList.toggle('d-display');
    this.smsVerificationsCheckTarget.classList.toggle('d-none');
  }

  /**
   * モーダルを開く
   */
  openModal() {
    this.modal.show();
  }

  /**
   * モーダルを閉じる
   */
  closeModal() {
    this.closeButtonTarget.click();
  }

  getController(event) {
    event.detail.setController((this));
    this.onEnd = event.detail.onEnd;
    return this;
  }
}
